import { Button } from "@inmagik/magik-ui"
import { useNavigate } from "react-router-dom"

export default function BottomFormFixed({ url}: { url: string }) {
  const navigate = useNavigate()
  return (
    <div
      className="position-fixed bottom-0 p-4 bg-white d-flex justify-content-between align-items-center"
      style={{
        zIndex: 1000,
        boxShadow: "0px -4px 20px 0px rgba(0, 0, 0, 0.05)",
        left: 244,
        width: "calc(100% - 244px)",
      }}
    >
      <Button onClick={() => navigate(url)} title="Annulla" size="md" outline leadingIcon="close" />
      <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
    </div>
  )
}
